declare global {
    interface Navigator {
        globalPrivacyControl?: boolean;
    }
}

export const PRIVACY_CHOICES_PATH = "/your-privacy-choices";
export const COOKIE_SETTINGS_ANCHOR = "cookie-settings";

export function readGlobalPrivacyControl(): boolean {
    return typeof navigator !== "undefined" && navigator.globalPrivacyControl === true;
}

// First-party cookies set by the analytics and advertising tags this site
// loads; the Privacy Policy's cookie list names the same set.
const TRACKING_COOKIE_PATTERN = /^(_ga(_.+)?|_gcl_au|_uetsid|_uetvid|_zitok|_sfid_.+)$/;

// Vendors write these on the parent domain (e.g. `.agencyq.com`), so an
// expiry without the matching `domain` attribute would leave them in place.
function cookieDomains(hostname: string): string[] {
    const labels = hostname.split(".");
    const domains = [""];
    for (let i = 0; i < labels.length - 1; i++) {
        domains.push(`; domain=.${labels.slice(i).join(".")}`);
    }
    return domains;
}

export function clearTrackingCookies(): void {
    const names = document.cookie
        .split(";")
        .map((cookie) => cookie.trim().split("=")[0])
        .filter((name) => TRACKING_COOKIE_PATTERN.test(name));

    for (const name of names) {
        for (const domain of cookieDomains(window.location.hostname)) {
            document.cookie = `${name}=; Max-Age=0; path=/${domain}`;
        }
    }
}

// Tags still running when consent is revoked (the Salesforce SDK, Bing UET)
// rewrite their cookies on the Save click and during unload, so the cleanup
// runs again on the next load, when those tags no longer load.
const PENDING_CLEANUP_KEY = "agencyq_clear_tracking_cookies";

export function scheduleTrackingCookieCleanup(): void {
    try {
        sessionStorage.setItem(PENDING_CLEANUP_KEY, "1");
    } catch {
        // Storage unavailable: the immediate cleanup still ran.
    }
}

export function runPendingTrackingCookieCleanup(): void {
    try {
        if (sessionStorage.getItem(PENDING_CLEANUP_KEY) !== "1") return;
        sessionStorage.removeItem(PENDING_CLEANUP_KEY);
    } catch {
        return;
    }
    clearTrackingCookies();
}

// Tags that already ran keep running until the page unloads, so revoking
// consent reloads the page once the new choice is saved.
export function reloadPage(): void {
    window.location.reload();
}
